import { useState, useEffect } from "react";
import { useAuth, API } from "../App";
import { Bell, X } from "lucide-react";
import { Button } from "./ui/button";
import axios from "axios";
import { toast } from "sonner";

export default function NotificationPrompt() {
  const { user, pushEnabled, togglePush } = useAuth();
  const [show, setShow] = useState(false);
  const [requesting, setRequesting] = useState(false);

  useEffect(() => {
    if (!user) return;
    // Show prompt if notifications not enabled and user hasn't dismissed
    const dismissed = sessionStorage.getItem('notif_prompt_dismissed');
    if (!dismissed && !pushEnabled && 'Notification' in window && Notification.permission !== 'denied') {
      const timer = setTimeout(() => setShow(true), 2000);
      return () => clearTimeout(timer);
    }
  }, [user, pushEnabled]);

  if (!show || pushEnabled) return null;

  const handleEnable = async () => {
    setRequesting(true);
    try {
      const result = await togglePush();
      if (result) {
        toast.success("Notificaciones activadas correctamente");
        setShow(false);
      } else {
        // Permission might have been denied by browser
        if ('Notification' in window && Notification.permission === 'denied') {
          toast.error("Permiso denegado. Ve a Ajustes de tu navegador > Notificaciones > Permitir para vynco.app");
        } else {
          toast.error("No se pudieron activar. Intenta desde Ajustes de la app.");
        }
      }
    } catch (e) {
      toast.error("Error al activar notificaciones");
    }
    setRequesting(false);
  };

  const handleDismiss = () => {
    sessionStorage.setItem('notif_prompt_dismissed', 'true');
    setShow(false);
  };

  return (
    <div className="fixed bottom-20 left-4 right-4 z-50 animate-in slide-in-from-bottom-4" data-testid="notification-prompt">
      <div className="bg-white rounded-2xl shadow-2xl border border-rose-100 p-5 relative">
        <button 
          onClick={handleDismiss}
          className="absolute top-3 right-3 text-[#B8AEA6] hover:text-[#2D2A28]"
        >
          <X className="w-5 h-5" />
        </button>
        
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 rounded-full bg-gradient-to-br from-rose-500 to-violet-600 flex items-center justify-center flex-shrink-0">
            <Bell className="w-6 h-6 text-white" />
          </div>
          <div className="flex-1">
            <h3 className="text-[#2D2A28] font-semibold text-base mb-1">
              Activa las notificaciones
            </h3>
            <p className="text-[#6B6560] text-sm mb-4">
              Recibe alertas de nuevos mensajes, likes y matches incluso con la app cerrada. No te pierdas ninguna conexion.
            </p>
            <Button
              data-testid="notification-prompt-enable"
              onClick={handleEnable}
              disabled={requesting}
              className="w-full h-11 bg-gradient-to-r from-rose-600 to-violet-600 text-white rounded-xl text-sm font-medium"
            >
              {requesting ? (
                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
              ) : (
                "Activar notificaciones"
              )}
            </Button>
            <p className="text-[#B8AEA6] text-xs text-center mt-2">
              Puedes desactivarlas en cualquier momento desde Ajustes
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
